import MarketingPageLayout from "../components/MarketingPageLayout";
import SeoHelmet from "../components/SeoHelmet";
import MarketingHero from "../components/MarketingHero";
import FeatureList from "../components/FeatureList";
import InternalLinks from "../components/InternalLinks";
import CtaFinal from "../components/CtaFinal";
import { MARKETING_META } from "../seoMeta";
import { buildWebPageLd } from "../../shared/seoJsonLd";
import useTranslation from "../../client/hooks/useTranslation";

const PATH = "/solutions/prop-trader-multi-comptes";

export default function SolutionMultiComptesPage() {
  const t = useTranslation();
  const m = MARKETING_META[PATH];
  const c = t.marketing.solutions.multiComptes;
  return (
    <MarketingPageLayout>
      <SeoHelmet
        path={PATH}
        title={m.title}
        description={m.description}
        jsonLd={[buildWebPageLd({ name: m.title, description: m.description, path: PATH })]}
      />
      <MarketingHero h1={c.h1} subtitle={c.subtitle} />
      <FeatureList items={c.bullets} />
      <InternalLinks
        links={[
          { to: "/tarifs", label: t.marketing.nav.pricing },
          { to: "/fonctionnalites/prop-firm-manager", label: t.marketing.nav.megaFeatures[1].label },
        ]}
      />
      <CtaFinal />
    </MarketingPageLayout>
  );
}
